<script>

import {FormWizard, TabContent} from "vue3-form-wizard";
import commentWithTools from "@/components/subcomponents/commentWithTools.vue";
import ratingAndComment from "@/components/subcomponents/ratingAndComment.vue";


import {useVuelidate} from '@vuelidate/core';
import {required, requiredIf, helpers} from '@vuelidate/validators';

import {api as viewerApi} from "v-viewer"

export default {
  inject: ['$Q', '$DateTime', '$axios', '$_'],
  setup() {
    return {v$: useVuelidate()}
  },
  name: "FinalQA-Form",
  props: {
    'profileID': String,
    'dataFrom': String,
    loginData: Object
  },
  components: {
    ratingAndComment, commentWithTools,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      feedbackSubmitted: false,
      feedbackSubmittedMsg: '',
      summaryProfile: {},
      summaryFeeback: {},
      summaryQA: {},
      summaryProfileLoaded: false,
      summaryFeebackLoaded: false,
      summaryQALoaded: false,
      surgeriesReturned: [],

      currentData: {},
      feedbackViewBtn: '',
      isReadOnly: false,
      disableQASaving: false,
      feedbackApproval: {
        status: '',
        reason: '',
        tagForFuture: ''
      },
      feebackQA: {
        surgeryPerformed: '',
        safeAskAmount: '-',
        surgeryAccuracy: {
          rating: '',
          comment: ''
        },
        storyQuoteQuality: {
          rating: '',
          comment: ''
        },
        imageQuality: {
          rating: '',
          comment: ''
        },
        safeScoreAccuracy: {
          rating: '',
          comment: ''
        },
      },
      approvalRemarksPlaceHolder: '',
      commentsArr: [],
      profileTS: '',
      profilePartner: '',
    }
  },
  validations() {
    let vm = this,
        validationObj = {};
    switch (vm.feedbackView) {
      case 'RateAndApprove':
        validationObj = {
          feedbackApproval: {
            status: {required: helpers.withMessage("Please select the approval status of the feedback", required)},
            reason: {requiredIfProfileNotApproved: helpers.withMessage("Please provide the reason for the approval status", requiredIf(vm.feedbackApproval.status === 'feedbackreturned' || vm.feedbackApproval.status === 'feedbackclose'))},
            tagForFuture: {requiredIfProfileApproved: helpers.withMessage("Please select if the feedback should be tagged for future reference", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice'))}
          },
          feebackQA: {
            surgeryPerformed: {requiredIfProfileApproved: helpers.withMessage("Please select the surgery performed", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice'))},
            surgeryAccuracy: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the surgery accuracy", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice'))},
              comment: {requiredIfRatingPoor: helpers.withMessage("Please provide the surgery accuracy comment", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice' && vm.feebackQA.surgeryAccuracy.rating <= 2))}
            },
            storyQuoteQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the story and quote quality", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice'))},
              comment: {required: helpers.withMessage("Please provide the story and quote quality comment", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice' && vm.feebackQA.storyQuoteQuality.rating <= 2))}
            },
            imageQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the images quality", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice'))},
              comment: {required: helpers.withMessage("Please provide the images quality comment", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice' && vm.feebackQA.imageQuality.rating <= 2))}
            },
            safeScoreAccuracy: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the SAFE-score accuracy", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice'))},
              comment: {required: helpers.withMessage("Please provide the SAFE-score accuracy comment", requiredIf(vm.feedbackApproval.status === 'feedbackinvoice' && vm.feebackQA.safeScoreAccuracy.rating <= 2))}
            }
          }
        }
        break;
      case 'commentOnly':
        validationObj = {
          profileComment: {required: helpers.withMessage("Please provide the comment text", required)}
        }
        break;
    }
    return validationObj;
  },
  computed: {
    feedbackView() {
      let vm = this,
          returnValue = 'commentOnly';
      if (vm.dataFrom === 'rejectedFeedback') {
        returnValue = 'commentOnly'
      } else {
        if (vm.feedbackViewBtn === '') {
          switch (vm.currentData.role) {
            case 'Representative':
              returnValue = 'commentOnly'
              break;
            case 'Coordinator':
              returnValue = 'RateAndApprove'
              break;
          }
        } else {
          returnValue = vm.feedbackViewBtn;
        }
      }

      return returnValue;
    },
    sourceImageURLs() {
      let vm = this;
      let imageURLs = {
        preopFace: [],
        preopCondition: [],
        preopIds: [],
        preopAttachments: [],
        postopFace: [],
        postopCondition: [],
        postopAttachments: []
      };
      vm.$_.forEach(vm.summaryProfile.faceImages, function (faceImage) {
        imageURLs.preopFace.push({
          'src': faceImage.view,
          'data-source': faceImage.view,
        });
      });
      vm.$_.forEach(vm.summaryFeeback.faceImages, function (faceImage) {
        imageURLs.postopFace.push({
          'src': faceImage.view,
          'data-source': faceImage.view,
        });
      });
      vm.$_.forEach(vm.summaryProfile.conditionImages, function (conditionImage) {
        imageURLs.preopCondition.push({
          'src': conditionImage.view,
          'data-source': conditionImage.view,
        });
      });
      vm.$_.forEach(vm.summaryFeeback.conditionImages, function (conditionImage) {
        imageURLs.postopCondition.push({
          'src': conditionImage.view,
          'data-source': conditionImage.view,
        });
      });
      vm.$_.forEach(vm.summaryProfile.identificationImages, function (identificationImage) {
        imageURLs.preopIds.push({
          'src': identificationImage.view,
          'data-source': identificationImage.view,
        });
      });
      imageURLs.preopAttachments.push({
        'src': vm.summaryProfile.waiverImages[0].view,
        'data-source': vm.summaryProfile.waiverImages[0].view,
      });
      imageURLs.postopAttachments.push({
        'src': vm.summaryFeeback.safeScaleReportImages[0].view,
        'data-source': vm.summaryFeeback.safeScaleReportImages[0].view,
      });
      vm.$_.forEach(vm.summaryProfile.additionalAttachments, function (additionalAttachment) {
        imageURLs.preopAttachments.push({
          'src': additionalAttachment.view,
          'data-source': additionalAttachment.view,
        });
      });
      vm.$_.forEach(vm.summaryFeeback.additionalAttachments, function (additionalAttachment) {
        imageURLs.postopAttachments.push({
          'src': additionalAttachment.view,
          'data-source': additionalAttachment.view,
        });
      });

      vm.$_.forEach(vm.commentsArr, function (comment, commentIndex) {
        imageURLs[`comment_${commentIndex}`] = [];
        vm.$_.forEach(comment.attachments, function (commentattachment) {
          imageURLs[`comment_${commentIndex}`].push({
            'src': commentattachment.view,
            'data-source': commentattachment.view,
          });
        });
      });

      return imageURLs;


    }
  },
  methods: {
    onTabChange: function () {
    },
    onComplete: function () {
      let vm = this;
      vm.processApproval();
    },
    closeProfileForm: function () {
      let vm = this;
      vm.$emit('QASaved');
    },
    async validateForm() {
      await this.v$.$validate();
    },
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    setFeedbackView: function (feedbackViewToShow) {
      let vm = this;
      vm.feedbackViewBtn = feedbackViewToShow;
    },
    imageRatingStar: function (emittedRating) {
      let vm = this;
      vm.feebackQA.imageQuality.rating = emittedRating
    },
    imageRatingComment: function (emittedComment) {
      let vm = this;
      vm.feebackQA.imageQuality.comment = emittedComment
    },
    safeScoreRatingStar: function (emittedRating) {
      let vm = this;
      vm.feebackQA.safeScoreAccuracy.rating = emittedRating
    },
    safeScoreRatingComment: function (emittedComment) {
      let vm = this;
      vm.feebackQA.safeScoreAccuracy.comment = emittedComment
    },
    surgeryAccuracyRatingStar: function (emittedRating) {
      let vm = this;
      vm.feebackQA.surgeryAccuracy.rating = emittedRating
    },
    surgeryAccuracyRatingComment: function (emittedComment) {
      let vm = this;
      vm.feebackQA.surgeryAccuracy.comment = emittedComment
    },
    storyQuoteRatingStar: function (emittedRating) {
      let vm = this;
      vm.feebackQA.storyQuoteQuality.rating = emittedRating
    },
    storyQuoteRatingComment: function (emittedComment) {
      let vm = this;
      vm.feebackQA.storyQuoteQuality.comment = emittedComment
    },
    processApproval: function () {
      let vm = this;
      vm.validateForm();


      if (vm.v$.$errors.length === 0) {

        vm.disableQASaving = true;

        const wizardButtons = document.querySelectorAll(".wizard-btn");
        vm.$_.forEach(wizardButtons, function (wizardButton) {
          wizardButton.disabled = true;
        });

        vm.$axios
            .post('/profile/action/approveFeedback', {
              feedbackApproval: vm.feedbackApproval,
              feebackQA: vm.feebackQA,
              summaryProfile: vm.summaryProfile,
              profilePartner: vm.summaryProfile.partnerid,
              profileId: vm.summaryProfile.profileIdentifier,
              coordData: vm.currentData
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.feedbackSubmittedMsg = response.data.msg;
                  vm.feedbackSubmitted = true;
                  break;
                case 'false':
                  vm.disableQASaving = false;
                  vm.$_.forEach(wizardButtons, function (wizardButton) {
                    wizardButton.disabled = false;
                  });
                  vm.feedbackSubmitted = false;
                  break;
              }
            });
      }
    },
    fetchComments: function () {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/fetchComments', {
              profileTS: vm.profileTS
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.commentsArr = response.data.comments;
                  break;
              }
            });
      } catch (error) {
        console.error(error);
      }
    },
    previewURL(imageSource, initialViewIndex) {
      let vm = this;
      viewerApi({
        options: {
          "inline": false,
          "button": true,
          "navbar": true,
          "title": true,
          "toolbar": true,
          "tooltip": true,
          "movable": true,
          "zoomable": true,
          "rotatable": true,
          "scalable": true,
          "transition": true,
          "fullscreen": true,
          "keyboard": true,
          "url": "data-source",
          initialViewIndex: initialViewIndex
        },
        images: vm.sourceImageURLs[imageSource]
      })
    },
  },
  async mounted() {
    let vm = this,
        storedAccount = localStorage.getItem("account");

    vm.IDB = await vm.getIDB()


    vm.summaryProfileLoaded = false;
    vm.summaryFeebackLoaded = false;
    vm.summaryQALoaded = false;

    vm.currentData = JSON.parse(storedAccount);

    let unapprovedFeedbackPatient = await vm.getPatientFromDb(vm.IDB, 'unapprovedFeedbacks', vm.profileID, 'caseId', false);

    if (typeof unapprovedFeedbackPatient[0] !== 'undefined') {
      vm.summaryProfile = unapprovedFeedbackPatient[0].caseData.profile;
      vm.summaryProfileLoaded = true;
      vm.summaryFeeback = unapprovedFeedbackPatient[0].caseData.feedback;
      vm.summaryFeebackLoaded = true;
      vm.summaryQA = unapprovedFeedbackPatient[0].caseData.caseQA;
      vm.summaryQALoaded = true;
      vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
      vm.profilePartner = unapprovedFeedbackPatient[0].caseData.profile.partnerid;
    }

    try {
      vm.$axios
          .post('/profile/action/fetchPartnerSurgeries', {
            profileID: vm.profileID,
            partnerid: vm.summaryProfile.partnerid
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            // console.log(response.data);
            vm.surgeriesReturned = response.data.surgeriesArr;
          });
    } catch (error) {
      console.error(error);
      vm.surgeriesReturned = [];
    }
  },
  watch: {
    feebackQA: {
      async handler(newValue) {
        let vm = this;
        if (newValue.surgeryPerformed !== '') {
          vm.$_.forEach(vm.surgeriesReturned, function (surgeryData) {
            if (vm.$_.trim(surgeryData.surgery).toLowerCase() === vm.$_.trim(newValue.surgeryPerformed).toLowerCase()) {
              vm.feebackQA.safeAskAmount = `${surgeryData.currency} ${surgeryData.cost}`;
            }
          });
        }
      },
      deep: true
    }
  },
}
</script>

<template>
  <div class="profile-form-container" v-if="!feedbackSubmitted">
    <FormWizard @on-complete="onComplete" @on-change="onTabChange" color="#094899" class="" step-size="md">
      <TabContent title="Profile" icon="fa fa-user">
        <div class="container" v-if="summaryProfileLoaded">
          <div class="container">
            <div class="columns is-multiline is-vcentered">

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="personalOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Case ID</div>
                  </div>
                  <div
                      class="column is-full has-text-left label-no-padding-top full-width-cell-last">
                    <label class="label has-text-centered">{{ summaryProfile.profileIdentifier }}</label>
                  </div>

                </div>
              </div>

              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Patient Information</h1>
              </div>

              <div class="column is-full">
                <div id="personalOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Personal</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Full Name</label>
                          <div class="has-text-centered">{{ summaryProfile.patientName }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Patient Hospital Number</label>
                          <div class="has-text-centered">{{ summaryProfile.inpatientNumber }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Gender</label>
                          <div class="has-text-centered">{{ summaryProfile.patientGender }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Date of Birth</label>
                          <div class="has-text-centered">{{ summaryProfile.patientDob }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Marital Status</label>
                          <div class="has-text-centered">{{ summaryProfile.patientMarital }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Education Level</label>
                          <div class="has-text-centered">{{ summaryProfile.patientEducation }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Patient Descriptor</label>
                          <div class="has-text-centered">{{ summaryProfile.patientDescription }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Has Health Insurance</label>
                          <div class="has-text-centered">{{ summaryProfile.hasInsurance }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Phone Number of the Patient</label>
                          <div class="has-text-centered">
                            {{ summaryProfile.patientPhoneNumber }}
                          </div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Government Identification</label>
                          <div class="has-text-centered">{{ summaryProfile.identificationDocument }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full" v-if="summaryProfile.patientAgeGroup ==='Minor'"></div>
              <div class="column is-full" v-if="summaryProfile.patientAgeGroup ==='Minor'">
                <div id="personalTwo" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text" v-if="summaryProfile.guardianIsNok==='No'">Guardian</div>
                    <div class="section-box-title-text" v-if="summaryProfile.guardianIsNok==='Yes'">Guardian and Next
                      of
                      Kin
                    </div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td colspan="2">
                          <label class="label has-text-left">Guardian Name</label>
                          <div class="has-text-centered">{{ summaryProfile.guardianName }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Guardian Phone Number</label>
                          <div class="has-text-centered">
                            {{ summaryProfile.guardianPhone }}
                          </div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Relationship</label>
                          <div class="has-text-centered">{{ summaryProfile.guardianRelation }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"
                   v-if="summaryProfile.guardianIsNok==='No' || summaryProfile.patientAgeGroup ==='adult'"></div>
              <div class="column is-full"
                   v-if="summaryProfile.guardianIsNok==='No' || summaryProfile.patientAgeGroup ==='adult'">
                <div id="personalThree" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Next of Kin</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td colspan="2">
                          <label class="label has-text-left">Name</label>
                          <div class="has-text-centered">{{ summaryProfile.nextOfKinName }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Phone Number</label>
                          <div class="has-text-centered">{{ summaryProfile.nextOfKinPhone }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Relationship</label>
                          <div class="has-text-centered">{{ summaryProfile.nextOfKinRelation }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="personalFour" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Origin</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td colspan="2">
                          <label class="label has-text-left">Location and District of Origin</label>
                          <div class="has-text-centered">{{ summaryProfile.patientOrigin }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Nearest Health Center</label>
                          <div class="has-text-centered">{{ summaryProfile.closestHealthCenter }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Referral From</label>
                          <div class="has-text-centered">{{ summaryProfile.referralFrom }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="personalFive" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Privacy</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td colspan="2">
                          <label class="label has-text-left">Has requested for privacy</label>
                          <div class="has-text-centered" v-html="summaryProfile.patientPrivacy"></div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Social Economic</h1>
              </div>

              <div class="column is-full">
                <div id="personalSix" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Employment</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Employment details of the {{
                              summaryProfile.patientOrGuardian
                            }}</label>
                          <div class="has-text-centered">
                            <strong>Profile: </strong>{{ summaryProfile.employmentProfile }}
                            <span v-if="summaryProfile.employmentType!=='-'"><br><strong>Type: </strong>{{
                                summaryProfile.employmentType
                              }}</span>
                            <br><strong>Description: </strong>
                            <span v-if="summaryProfile.employmentDescription!=='-'">
                      {{ summaryProfile.employmentDescription }}
                    </span>
                            <span v-if="summaryProfile.selfemploymentDescription!=='-'">
                      {{ summaryProfile.selfemploymentDescription }}
                    </span>
                          </div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Monthly income of the {{
                              summaryProfile.patientOrGuardian
                            }}
                            (USD)</label>
                          <div class="has-text-centered">{{ summaryProfile.monthlyIncome }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="personalSeven" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Housing</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Type of Housing</label>
                          <div class="has-text-centered">{{ summaryProfile.housingType }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Number of rooms</label>
                          <div class="has-text-centered">{{ summaryProfile.houseRooms }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="personalEight" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Energy</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">The main source of power (Lighting)</label>
                          <div class="has-text-centered">{{ summaryProfile.lightingEnergy }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">The main source of energy (cooking)</label>
                          <div class="has-text-centered">{{ summaryProfile.cookingEnergy }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Family</h1>
              </div>

              <div class="column is-full">
                <div id="personalNine" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Household</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Number of household members the {{
                              summaryProfile.patientOrGuardian
                            }}
                            supports</label>
                          <div class="has-text-centered">{{ summaryProfile.supportingHouseHoldOf }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Number of Children the {{
                              summaryProfile.patientOrGuardian
                            }}
                            has</label>
                          <div class="has-text-centered">{{ summaryProfile.numberOfChildren }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Illness Profile</h1>
              </div>
              <div class="column is-full">
                <div id="illnessOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Surgery</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Condition</label>
                          <div class="has-text-centered">{{ summaryProfile.patientCondition }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Length of stay with condition</label>
                          <div class="has-text-centered">{{ summaryProfile.timeWithCondition }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Type</label>
                          <div class="has-text-centered">{{ summaryProfile.surgeryType }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="2">
                          <label class="label has-text-left">Surgery required</label>
                          <div class="has-text-centered">{{ summaryProfile.surgeryRequired }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Estimated Date of Surgery</label>
                          <div class="has-text-centered">{{ summaryProfile.estimatedSurgeryDay }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Gravidity</label>
                          <div class="has-text-centered">{{ summaryProfile.gravidity }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Parity</label>
                          <div class="has-text-centered">{{ summaryProfile.parity }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Safe Ask</label>
                          <div class="has-text-centered safe-ask-amount">{{ summaryProfile.safeAskAmount }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Co-Payment Amount</label>
                          <div class="has-text-centered" v-html="summaryProfile.copaymentAmount"></div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="illnessTwo" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Transport</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Time taken to reach the hospital</label>
                          <div class="has-text-centered">{{ summaryProfile.timeTakenToHospital }}</div>
                        </td>
                        <td class="middle-table-cell">
                          <label class="label has-text-left">Main mode of transport to the hospital</label>
                          <div class="has-text-centered">{{ summaryProfile.modeOfTransport }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Amount spent on transport round trip</label>
                          <div class="has-text-centered">{{ summaryProfile.costOfTransport }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="illnessThree" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Patient Story</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td>
                          <div class="has-text-justified">{{ summaryProfile.patientStory }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="illnessFour" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Personal Quote</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td>
                          <div class="has-text-justified">{{ summaryProfile.patientQuote }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline">

              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
              </div>

              <div class="column is-full" v-if="summaryProfile.faceImages.length!==0">
                <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Pre-OP Photos</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(faceImage, index) in summaryProfile.faceImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('preopFace',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face"
                             class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          faceImage.timestamp
                        }}</span>
                      </div>
                      <div class="buttons has-addons is-centered">
                        <a class="button" v-if="faceImage.location" v-bind:href="faceImage.location"
                           target="_blank">Location</a>
                        <a v-bind:href="`${faceImage.download}?form=profile&fullname=${summaryProfile.patientName}`"
                           target="_blank"
                           class="button">Download</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full" v-if="summaryProfile.conditionImages.length!==0"></div>
              <div class="column is-full" v-if="summaryProfile.conditionImages.length!==0">
                <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Condition</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(conditionImage, index) in summaryProfile.conditionImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('preopCondition',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${conditionImage.thumbnail}`" alt="Condition Image"
                             class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          conditionImage.timestamp
                        }}</span></div>

                      <div class="buttons has-addons is-centered">
                        <a class="button" v-if="conditionImage.location" v-bind:href="conditionImage.location"
                           target="_blank">Location</a>
                        <a v-bind:href="`${conditionImage.download}?form=profile&fullname=${summaryProfile.patientName}`"
                           target="_blank"
                           class="button">Download</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full" v-if="summaryProfile.identificationImages.length!==0"></div>
              <div class="column is-full" v-if="summaryProfile.identificationImages.length!==0">
                <div id="AttachmentsFour" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Identification Documents</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(identificationImage, index) in summaryProfile.identificationImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('preopIds',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${identificationImage.thumbnail}`" alt="Identification Image"
                             class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          identificationImage.timestamp
                        }}</span>
                      </div>

                      <div class="buttons has-addons is-centered">
                        <a v-bind:href="`${identificationImage.download}?form=profile&fullname=${summaryProfile.patientName}`"
                           target="_blank"
                           class="button">Download</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Additional Attachments</div>
                  </div>
                  <div class="column is-one-quarter">
                    <div class="image-relative-container" v-on:click="previewURL('preopAttachments',0)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${summaryProfile.waiverImages[0].thumbnail}`" alt="Waiver"
                             class="image">
                      </div>
                      <div class="buttons has-addons is-centered">
                        <a v-bind:href="`${summaryProfile.waiverImages[0].download}?form=profile&fullname=${summaryProfile.patientName}`"
                           target="_blank"
                           class="button">Download</a>
                      </div>
                    </div>
                  </div>
                  <div class="column is-one-quarter"
                       v-for="(additionalAttachment, index) in summaryProfile.additionalAttachments"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('preopAttachments',index+1)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${additionalAttachment.thumbnail}`"
                             alt="Additional Attachment"
                             class="image">
                      </div>
                      <div class="buttons has-addons is-centered">
                        <a v-bind:href="`${additionalAttachment.download}?form=profile&fullname=${summaryProfile.patientName}`"
                           target="_blank"
                           class="button">Download</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Checklist and Confirmation</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td>
                          <label class="label has-text-left">Is the proposed treatment expected to save the patient’s
                            life
                            or significantly increase their standard of living?</label>
                          <div class="has-text-centered">{{ summaryProfile.treatmentChangeLife }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label class="label has-text-left">Do you agree to provide SAFE a complete treatment update
                            within
                            30 days after the proposed treatment date listed in this form?</label>
                          <div class="has-text-centered">{{ summaryProfile.treatmentUpdate }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>

            </div>
          </div>
        </div>
      </TabContent>
      <TabContent title="Feedback" icon="fa fa-user-doctor">
        <div class="container" v-if="summaryFeebackLoaded">
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Profile {{ profileID }}</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Profile Data</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Full Name</label>
                          <div class="has-text-centered">{{ summaryProfile.patientName }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Patient Hospital Number</label>
                          <div class="has-text-centered">{{ summaryProfile.inpatientNumber }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Gender</label>
                          <div class="has-text-centered">{{ summaryProfile.patientGender }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Date of Birth</label>
                          <div class="has-text-centered">{{ summaryProfile.patientDob }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Type</label>
                          <div class="has-text-centered">{{ summaryProfile.surgeryType }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="2">
                          <label class="label has-text-left">Surgery required</label>
                          <div class="has-text-centered">{{ summaryProfile.surgeryRequired }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Estimated Date of Surgery</label>
                          <div class="has-text-centered">{{ summaryProfile.estimatedSurgeryDay }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Surgery</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Surgery Data</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Status</label>
                          <div class="has-text-centered">{{ summaryFeeback.surgeryStatus }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3"
                            v-if="summaryFeeback.surgeryStatus==='Done'">
                          <label class="label has-text-left">Actual Surgery</label>
                          <div class="has-text-centered">{{ summaryFeeback.actualSurgery }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3" v-else>
                          <label class="label has-text-left">Reason</label>
                          <div class="has-text-centered">{{ summaryFeeback.surgeryStatusReason }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Admission</label>
                          <div class="has-text-centered">{{ summaryFeeback.admissionData }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Surgery</label>
                          <div class="has-text-centered">{{ summaryFeeback.surgeryData }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Discharge</label>
                          <div class="has-text-centered">{{ summaryFeeback.dischargeData }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Final Bill</label>
                          <div class="has-text-centered">{{ summaryFeeback.finalBill }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="3">
                          <label class="label has-text-left">Co-payment</label>
                          <div class="has-text-centered" v-html="summaryFeeback.coPaymentDisplay"></div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">SAFE-Score Rating</label>
                          <div class="has-text-centered">{{ summaryFeeback.safeScoreRating }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="3">
                          <label class="label has-text-left">SAFE-Score Comment</label>
                          <div class="has-text-centered" v-html="summaryFeeback.safeScoreComment"></div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" v-if="summaryFeeback.isBirthSurgery==='YES'">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3">&nbsp;</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryBirth" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Birth Outcome</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Gravidity</label>
                          <div class="has-text-centered">{{ summaryFeeback.birthOutcomeGravidity }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Parity</label>
                          <div class="has-text-centered">{{ summaryFeeback.birthOutcomeParity }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Births</label>
                          <div class="has-text-centered">{{ summaryFeeback.birthOutcomeChildrenCount }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <div class="columns is-multiline is-vcentered">
                            <div class="column is-full"></div>
                            <div v-for="(child, index) in summaryFeeback.childrenFormated"
                                 class="column is-half has-text-centered" v-bind:key="index"
                                 v-html="child"></div>
                            <div class="column is-full"></div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3">&nbsp;</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Patient Story</div>
                  </div>
                  <div class="column is-full" v-html="summaryFeeback.patientStory"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3">&nbsp;</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Patient Quote</div>
                  </div>
                  <div class="column is-full" v-html="summaryFeeback.patientQuote"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline">

              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
              </div>

              <div class="column is-full" v-if="summaryFeeback.faceImages.length!==0">
                <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Post-OP Photos</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(faceImage, index) in summaryFeeback.faceImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('postopFace',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face"
                             class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          faceImage.timestamp
                        }}</span>
                      </div>
                      <div><strong>Location:</strong> <a v-bind:href="faceImage.location" target="_blank"
                                                         v-if="faceImage.location!==''">Here</a>
                        <span v-else></span>
                      </div>
                      <a v-bind:href="`${faceImage.download}?form=feedback&fullname=${summaryProfile.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full" v-if="summaryFeeback.conditionImages.length!==0"></div>
              <div class="column is-full" v-if="summaryFeeback.conditionImages.length!==0">
                <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Condition</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(conditionImage, index) in summaryFeeback.conditionImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('postopCondition',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${conditionImage.thumbnail}`" alt="Condition Image"
                             class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          conditionImage.timestamp
                        }}</span></div>
                      <div><strong>Location:</strong> <a v-bind:href="conditionImage.location" target="_blank"
                                                         v-if="conditionImage.location!==''">Here</a>
                        <span v-else></span>
                      </div>
                      <a v-bind:href="`${conditionImage.download}?form=feedback&fullname=${summaryProfile.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Additional Attachments</div>
                  </div>
                  <div class="column is-one-quarter" v-if="summaryFeeback.safeScaleReportImages.length!==0">
                    <div class="image-relative-container" v-on:click="previewURL('postopAttachments',0)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${summaryFeeback.safeScaleReportImages[0].thumbnail}`"
                             alt="Surgical Outcome Document"
                             class="image">
                      </div>
                      <a v-bind:href="`${summaryFeeback.safeScaleReportImages[0].download}?form=feedback&fullname=${summaryProfile.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                  <div class="column is-one-quarter"
                       v-for="(additionalAttachment, index) in summaryFeeback.additionalAttachments"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('postopAttachments',index+1)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${additionalAttachment.thumbnail}`"
                             alt="Additional Attachment"
                             class="image">
                      </div>
                      <a v-bind:href="`${additionalAttachment.download}?form=feedback&fullname=${summaryProfile.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Acknowledgement</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td>
                          <label class="label has-text-left">By submitting this form, you acknowledge that all of the
                            information contained in this document is true to the best of your knowledge. If at any
                            point the information contained above becomes inaccurate, you agree to notify the SAFE
                            Program as soon as possible.</label>
                          <div class="has-text-centered">{{ summaryFeeback.signedAcknowledgement }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>

            </div>
          </div>
        </div>
      </TabContent>
      <TabContent title="QA" icon="fa fa-medal">
        <div class="container" v-if="summaryProfileLoaded && summaryFeebackLoaded">
          <div class="container">
            <div class="columns is-multiline is-mobile is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Profile {{ profileID }}</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Surgery QA</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Surgery Required</label>
                          <div class="has-text-centered"><strong>Type:</strong> {{
                              summaryProfile.surgeryType
                            }}<br><strong>Surgery:</strong> {{ summaryProfile.surgeryRequired }}
                          </div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Surgery Performed</label>
                          <div class="has-text-centered">{{ summaryFeeback.actualSurgery }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Surgery Expected Date</label>
                          <div class="has-text-centered">{{ summaryProfile.estimatedSurgeryDay }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Surgery Actual Date</label>
                          <div class="has-text-centered">{{ summaryFeeback.surgeryData }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="box has-text-left">
                            <span v-html="summaryQA.surgeryDateQA"></span>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>

              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Dates QA</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Profile Creation</label>
                          <div class="has-text-centered">{{ summaryProfile.profileCreationDate }}</div>
                        </td>
                        <td class="middle-table-cell">
                          <label class="label has-text-left">Profile Submission</label>
                          <div class="has-text-centered">{{ summaryProfile.profileSubmissionDate }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Profile Approval</label>
                          <div class="has-text-centered">{{ summaryProfile.approved_at }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Surgery Date</label>
                          <div class="has-text-centered">{{ summaryFeeback.surgeryData }}</div>
                        </td>
                        <td class="middle-table-cell">
                          <label class="label has-text-left">Feedback Creation</label>
                          <div class="has-text-centered">{{ summaryFeeback.created_at }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Feedback Submission</label>
                          <div class="has-text-centered">{{ summaryFeeback.submitted_at }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="box has-text-left">
                            <span v-html="summaryQA.profileSubmission"></span><br>
                            <span v-html="summaryQA.profileSurgery"></span><br>
                            <span v-html="summaryQA.profileApproval"></span><br>
                            <span v-html="summaryQA.profileApprovalSurgery"></span><br>
                            <span v-html="summaryQA.feedbackCreation"></span><br>
                            <span v-html="summaryQA.feedbackSubmission"></span><br>
                            <span v-html="summaryQA.feedbackSurgery"></span><br>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>

              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Images QA</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Pre-Op Photos</label>
                          <div class="has-text-centered">
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(faceImage, index) in summaryProfile.faceImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('preopFace',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ faceImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="faceImage.location" target="_blank"
                                     v-if="faceImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="summaryQA.profileFacesQA[index].profileSubmission"></span><br>
                                  <span v-html="summaryQA.profileFacesQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(conditionImage, index) in summaryProfile.conditionImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('preopCondition',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ conditionImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="conditionImage.location" target="_blank"
                                     v-if="conditionImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="summaryQA.profileConditionsQA[index].feedbackSubmission"></span><br>
                                  <span v-html="summaryQA.profileConditionsQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Post-Op Photos</label>
                          <div class="has-text-centered">
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(faceImage, index) in summaryFeeback.faceImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('postopFace',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ faceImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="faceImage.location" target="_blank"
                                     v-if="faceImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="summaryQA.feedbackFacesQA[index].feedbackSubmission"></span><br>
                                  <span v-html="summaryQA.feedbackFacesQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(conditionImage, index) in summaryFeeback.conditionImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('postopCondition',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ conditionImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="conditionImage.location" target="_blank"
                                     v-if="conditionImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="summaryQA.feedbackConditionsQA[index].feedbackSubmission"></span><br>
                                  <span v-html="summaryQA.feedbackConditionsQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline is-mobile">

              <div class="column is-full" v-if="!isReadOnly">
                <h1 class="is-size-3 is-underlined" v-if="currentData.role==='Coordinator'">Approval and Comments</h1>
                <h1 class="is-size-3 is-underlined" v-if="currentData.role==='Representative'">Comments</h1>
              </div>

              <div class="column is-full tabs is-boxed" v-if="currentData.role==='Coordinator' && !isReadOnly">
                <ul>
                  <li v-bind:class="{'is-active':feedbackView==='RateAndApprove'}"
                      v-on:click="setFeedbackView('RateAndApprove')"
                  >
                    <a>Rating and Approval</a>
                  </li>
                  <li v-bind:class="{'is-active':feedbackView==='commentOnly'}"
                      v-on:click="setFeedbackView('commentOnly')"
                  >
                    <a>Comment Only</a>
                  </li>
                </ul>
              </div>
              <div class="column is-full" v-if="!isReadOnly"></div>


              <div class="column is-full" v-if="feedbackView==='commentOnly'">
                <div id="CoordFeedbackOne" class="columns is-multiline is-mobile is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Comments</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr v-if="commentsArr.length===0 && isReadOnly">
                        <td>There are no comments</td>
                      </tr>
                      <tr v-for="(comment, commentIndex) in commentsArr"
                          v-bind:key="commentIndex">
                        <td>
                          <div class="columns is-multiline">
                            <div class="column is-full has-text-justified">{{ comment.commentText }}</div>
                            <div class="column is-one-quarter"
                                 v-for="(attachment, attachmentIndex) in comment.attachments"
                                 v-bind:key="attachmentIndex">
                              <div class="image-relative-container"
                                   v-on:click="previewURL(`comment_${commentIndex}`,attachmentIndex)">
                                <div class="image-flex-container zoom-image">
                                  <img v-bind:src="`${attachment.thumbnail}`" alt="Comment Attachment" class="image">
                                </div>
                              </div>
                              <a v-bind:href="`${attachment.download}?form=comment&fullname=${summaryProfile.patientName}`"
                                 target="_blank"
                                 class="button is-fullwidth">Download</a>
                            </div>
                            <div class="column is-full has-text-right">{{ comment.postdBy.name }} at {{
                                comment.commentDate
                              }}
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="!isReadOnly">
                        <td>
                          <commentWithTools
                              v-bind:profileTS="profileTS"
                              v-bind:profilePartner="profilePartner"
                              v-bind:textAreaPlaceholder="''"
                              v-bind:textAreaGuideline="''"
                              v-bind:commentError="false"
                              v-on:commentPosted="fetchComments"
                          >
                          </commentWithTools>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="column is-full" v-if="feedbackView==='RateAndApprove' && !isReadOnly">
                <div id="CoordFeedbackTwo" class="columns is-multiline is-mobile is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Coordinator Action</div>
                  </div>

                  <div class="column is-one-quarter">
                    Approval Status:
                  </div>
                  <div class="column is-three-quarters">
                    <div class="fancy-input-group columns is-multiline is-mobile is-vcentered"
                         v-bind:class="{'error-input':v$.feedbackApproval.status.$errors.length>0}">
                      <input type="radio" name="feedbackstatus" id="feedbackinvoice" value="feedbackinvoice"
                             class="fancy-input"
                             v-model="feedbackApproval.status"/>
                      <label for="feedbackinvoice"
                             class="fancy-input-label column no-wrapping-label">Invoice</label>
                      <input type="radio" name="feedbackstatus" id="feedbackreturned" value="feedbackreturned"
                             class="fancy-input" v-model="feedbackApproval.status"/>
                      <label for="feedbackreturned" class="fancy-input-label column no-wrapping-label">Send Back</label>
                      <input type="radio" name="feedbackstatus" id="feedbackclose" value="feedbackclose"
                             class="fancy-input"
                             v-model="feedbackApproval.status"/>
                      <label for="feedbackclose"
                             class="fancy-input-label column no-wrapping-label">Close</label>
                    </div>
                  </div>

                  <div class="column is-full has-text-centered"
                       v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <label class="label has-text-centered">Surgery Confirmation</label>
                    <div class="columns is-multiline is-mobile is-vcentered">
                      <div class="column is-half">
                        <label class="label has-text-centered">Surgery Performed</label>
                        <div class="field">
                          <p class="control">
                        <span class="select is-fullwidth">
                          <select v-model="feebackQA.surgeryPerformed"
                                  v-bind:class="{'error-input':v$.feebackQA.surgeryPerformed.$errors.length>0}">
                            <option disabled value="">Select One</option>
                            <option v-for="(surgeryAvailable, index) in surgeriesReturned"
                                    v-bind:value="surgeryAvailable.surgery" v-bind:key="index">{{
                                surgeryAvailable.surgery
                              }}</option>
                          </select>
                        </span>
                          </p>
                        </div>
                      </div>
                      <div class="column is-half">
                        <label class="label has-text-centered">Safe Ask</label>
                        <div class="safe-ask-amount">{{ feebackQA.safeAskAmount }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="column is-full has-text-centered label-no-padding-bottom"
                       v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <label class="label has-text-centered">Accuracy of Surgery</label>
                  </div>
                  <div class="column is-full input-no-padding-top" v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <ratingAndComment v-bind:textAreaPlaceholder="'Surgery accuracy comment'"
                                          v-bind:textAreaGuideline="''"
                                          v-bind:maxRating="5"
                                          v-bind:ratingError="feebackQA.surgeryAccuracy.rating===0"
                                          v-bind:commentError="$_.trim(feebackQA.surgeryAccuracy.comment)==='' && feebackQA.surgeryAccuracy.rating<=2"
                                          v-bind:ratingValue="feebackQA.surgeryAccuracy.rating"
                                          v-bind:ratingType="'rating'"
                                          v-on:starRating="surgeryAccuracyRatingStar"
                                          v-on:commentRating="surgeryAccuracyRatingComment"
                        ></ratingAndComment>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-centered label-no-padding-bottom"
                       v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <label class="label has-text-centered">Quality of Story and Quote</label>
                  </div>
                  <div class="column is-full input-no-padding-top" v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <ratingAndComment v-bind:textAreaPlaceholder="'Story and quote rating comment'"
                                          v-bind:textAreaGuideline="''"
                                          v-bind:maxRating="5"
                                          v-bind:ratingError="feebackQA.storyQuoteQuality.rating===0"
                                          v-bind:commentError="$_.trim(feebackQA.storyQuoteQuality.comment)===''  && feebackQA.storyQuoteQuality.rating<=2"
                                          v-bind:ratingValue="feebackQA.storyQuoteQuality.rating"
                                          v-bind:ratingType="'rating'"
                                          v-on:starRating="storyQuoteRatingStar"
                                          v-on:commentRating="storyQuoteRatingComment"
                        ></ratingAndComment>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-centered label-no-padding-bottom"
                       v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <label class="label has-text-centered">Quality of Images</label>
                  </div>
                  <div class="column is-full input-no-padding-top" v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <ratingAndComment v-bind:textAreaPlaceholder="'Image rating comment'"
                                          v-bind:textAreaGuideline="''"
                                          v-bind:maxRating="5"
                                          v-bind:ratingError="feebackQA.imageQuality.rating===0"
                                          v-bind:commentError="$_.trim(feebackQA.imageQuality.comment)===''  && feebackQA.imageQuality.rating<=2"
                                          v-bind:ratingValue="feebackQA.imageQuality.rating"
                                          v-bind:ratingType="'rating'"
                                          v-on:starRating="imageRatingStar"
                                          v-on:commentRating="imageRatingComment"
                        ></ratingAndComment>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-centered label-no-padding-bottom"
                       v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <label class="label has-text-centered">Accuracy of SAFE score</label>
                  </div>
                  <div class="column is-full input-no-padding-top" v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <ratingAndComment v-bind:textAreaPlaceholder="'SAFE Score accuracy comment'"
                                          v-bind:textAreaGuideline="''"
                                          v-bind:maxRating="5"
                                          v-bind:ratingError="feebackQA.safeScoreAccuracy.rating===0"
                                          v-bind:commentError="$_.trim(feebackQA.safeScoreAccuracy.comment)===''  && feebackQA.safeScoreAccuracy.rating<=2"
                                          v-bind:ratingValue="feebackQA.safeScoreAccuracy.rating"
                                          v-bind:ratingType="'rating'"
                                          v-on:starRating="safeScoreRatingStar"
                                          v-on:commentRating="safeScoreRatingComment"
                        ></ratingAndComment>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-centered label-no-padding-bottom"
                       v-if="feedbackApproval.status !== ''">
                    <label class="label has-text-centered">Approval Remarks</label>
                  </div>
                  <div class="column is-full input-no-padding-top" v-if="feedbackApproval.status !== ''">
              <textarea class="textarea" v-bind:placeholder="approvalRemarksPlaceHolder"
                        v-on:keyup="resize('noApprovalReason')"
                        v-bind:class="{'error-input':v$.feedbackApproval.reason.$errors.length>0}"
                        ref="noApprovalReason"
                        v-model.trim="feedbackApproval.reason"></textarea>
                  </div>

                  <div class="column is-full has-text-centered label-no-padding-bottom"
                       v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <label class="label has-text-centered">Tag Feedback For future Use</label>
                  </div>
                  <div class="column is-full" v-if="feedbackApproval.status === 'feedbackinvoice'">
                    <div class="fancy-input-group columns is-multiline is-mobile is-vcentered"
                         v-bind:class="{'error-input':v$.feedbackApproval.tagForFuture.$errors.length>0}">
                      <input type="radio" name="taggingstatus" id="taggingyes" value="taggingyes"
                             class="fancy-input"
                             v-model="feedbackApproval.tagForFuture"/>
                      <label for="taggingyes"
                             class="fancy-input-label column no-wrapping-label">Yes</label>
                      <input type="radio" name="taggingstatus" id="taggingno" value="taggingno"
                             class="fancy-input" v-model="feedbackApproval.tagForFuture"/>
                      <label for="taggingno" class="fancy-input-label column no-wrapping-label">No</label>
                    </div>
                  </div>

                  <div class="column is-full"></div>
                  <div class="column is-full" v-if="v$.$errors.length">
                    <div id="AttachmentsSeven"
                         class="columns is-multiline is-mobile is-vcentered section-box section-box-errors">
                      <div class="column is-full section-box-title-column">
                        <div class="section-box-title-text section-box-title-text-error">All Errors & Notices</div>
                      </div>
                      <div class="column is-full">
                        <p class="has-text-left"
                           v-for="error of v$.$errors"
                           :key="error.$uid"
                        ><strong class="strong-text-error">{{ error.$message }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="column is-full" v-if="v$.$errors.length"></div>


                  <div class="column is-full"></div>
                </div>
              </div>

              <div class="column is-full"></div>
            </div>
          </div>
        </div>
      </TabContent>
    </FormWizard>
  </div>
  <div class="profile-form-container center-screen" v-if="feedbackSubmitted">

    <div class="columns is-multiline is-vcentered">
      <div class="column is-full">
        <a href="#" target="_blank" class="thumb fa fa-thumbs-up"></a>
        <div class="circle-wrap">
          <div class="circle-lg"></div>
        </div>
        <div class="dots-wrap">
          <div class="dot dot--t"></div>
          <div class="dot dot--tr"></div>
          <div class="dot dot--br"></div>
          <div class="dot dot--b"></div>
          <div class="dot dot--bl"></div>
          <div class="dot dot--tl"></div>
        </div>
      </div>
      <div class="column is-full" v-html="feedbackSubmittedMsg" style="margin-top: 60px"></div>
      <div class="column is-full">
        <button class='button is-fullwidth' v-on:click="closeProfileForm">OK</button>
      </div>
    </div>

    <!--    <span v-html="feedbackSubmittedMsg"></span>-->
    <!--    <br>-->
    <!--    <button class='button is-fullwidth' v-on:click="closeProfileForm">OK</button>-->
  </div>
</template>

<style scoped>
@import "@/assets/fontawesome-free-6.5.2-web/css/all.min.css";

.profile-form-container {
  padding: 20px;
}

[v-cloak] {
  display: none;
}

.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
  opacity: 0.9 !important;
}

.left-side-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
}

.right-side-table-cell {
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.middle-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.is-200x200 {
  height: 200px;
  width: 200px;
}

.can-scroll-content {
  overflow-x: scroll;
}

.qa-ok {
  color: green;
}

.qa-nok {
  color: red;
}
</style>